import ogAxios from 'axios'

export const axios = ogAxios.create({
  baseURL: import.meta.env.DEV ? `http://${location.hostname}:5001/bodyfast-development/us-central1/api` : ''
})

export const fetcher = async (urlKey: string) => {
  const res = await axios({
    url: urlKey,
    method: 'GET'
  })

  return res.data
}
